"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FhtPriorityPonds_exports = {};
__export(FhtPriorityPonds_exports, {
  FhtPriorityPonds: () => FhtPriorityPonds,
  customEmptyMarker: () => customEmptyMarker
});
module.exports = __toCommonJS(FhtPriorityPonds_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_color = __toESM(require("color"));
var import_lodash = require("lodash");
var import_core = require("../../core/index.js");
const customEmptyMarker = import_topo_map.marker.fromColorFunc(
  (isFill) => isFill ? (0, import_color.default)("transparent") : (0, import_color.default)("rgba(128, 128, 128, .4)")
);
const FhtPriorityPonds = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("FhtPriorityPonds"),
  title: "Priority Ponds",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("FhtPriorityPonds"),
      title: "Priority Ponds",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("FhtPriorityPonds"),
        attribution: []
      }),
      defaultAttribute: "displayCriterion",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey Details",
          attributes: [
            (0, import_topo_map.timestampAttr)({
              label: "Date/Time",
              attributeId: "timestamp",
              buckets: "auto"
            }),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.numberAttr)({
              attributeId: "displayCriterion",
              label: "Criterion",
              buckets: [
                ...(0, import_lodash.range)(0, 7).map((n) => (0, import_topo_map.lookupBucket)(n + 1, import_topo_map.marker.hue(380 * n / 7), `Criterion ${n + 1}`)),
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "-")
              ]
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "1. Annex 1 Habitats",
          attributes: [
            criterionAppliesAttr(1),
            (0, import_topo_map.enumAttr)({
              label: "Annex 1 Habitat Directive Type",
              attributeId: "criterion1_annex1Type",
              enum: import_inventory_enums.FhtPriorityPondsAnnex1TypeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "2. Important Species",
          attributes: [
            criterionAppliesAttr(2),
            (0, import_topo_map.booleanAttr)({
              label: "Great Crested Newt",
              attributeId: "criterion2_greatCrestedNewt",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Common Toad",
              attributeId: "criterion2_commonToad",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Other Species",
              attributeId: "criterion2_other",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "eDNA Record",
              attributeId: "criterion2_verifiedByEDna",
              buckets: booleanBuckets("lightgreen")
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "3. Rich Species Assemblages",
          attributes: [
            criterionAppliesAttr(3),
            (0, import_topo_map.booleanAttr)({
              label: "Amphibian Assemblage",
              attributeId: "criterion3_amphibianAssemblage",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Dragonfly Assemblage",
              attributeId: "criterion3_dragonflyAssemblage",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Extremely Rich Site For Plants",
              attributeId: "criterion3_richSiteForPlants",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Extremely Rich Site For Aquatic Invertebrates",
              attributeId: "criterion3_richSiteForAquaticInvertebrates",
              buckets: booleanBuckets("lightgreen")
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "4. High Quality (PSYM)",
          attributes: [
            criterionAppliesAttr(4),
            (0, import_topo_map.booleanAttr)({
              label: "PSYM Classification 'Good'",
              attributeId: "criterion4_goodPsymScore",
              buckets: booleanBuckets("lightgreen")
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "5. Important Pond Types",
          attributes: [
            criterionAppliesAttr(5),
            (0, import_topo_map.booleanAttr)({
              label: "Ice Age Pond",
              attributeId: "criterion5_iceAgePond",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Dune Slack Pond",
              attributeId: "criterion5_duneSlackPond",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Floating Vegetation Mat",
              attributeId: "criterion5_floatingVegetationMat",
              buckets: booleanBuckets("lightgreen")
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Other Important Pond Type",
              attributeId: "criterion5_other",
              buckets: booleanBuckets("lightgreen")
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "6. Priority Pond Assessment (PASS)",
          attributes: [
            criterionAppliesAttr(6),
            (0, import_topo_map.booleanAttr)({
              label: "Priority Pond Predicted (PASS)",
              attributeId: "criterion6_priority",
              buckets: booleanBuckets("lightgreen")
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "7. Clean Water",
          attributes: [
            criterionAppliesAttr(7),
            (0, import_topo_map.booleanAttr)({
              label: "Low Nitrate and Phosphate",
              attributeId: "criterion7_lowNitrateAndPhosphate",
              buckets: booleanBuckets("lightgreen")
            })
          ]
        })
      ]
    })
  ]
});
function criterionAppliesAttr(num) {
  return (0, import_topo_map.booleanAttr)({
    label: "Criterion Applies",
    attributeId: `criterion${num}_applies`,
    buckets: booleanBuckets("yellow")
  });
}
function booleanBuckets(yesColor) {
  return [(0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor(yesColor)), (0, import_topo_map.lookupBucket)(false, customEmptyMarker)];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FhtPriorityPonds,
  customEmptyMarker
});
//# sourceMappingURL=FhtPriorityPonds.js.map
